import { render, staticRenderFns } from "./QuickInputTag.vue?vue&type=template&id=1bbe7c66&scoped=true"
import script from "./QuickInputTag.vue?vue&type=script&lang=js"
export * from "./QuickInputTag.vue?vue&type=script&lang=js"
import style0 from "./QuickInputTag.vue?vue&type=style&index=0&id=1bbe7c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe7c66",
  null
  
)

export default component.exports